<template>
	<AtomInputUtilWrapper
		:title="title"
		:is-required="isRequired"
		:error-messages="errorMessages"
		no-error-icons
	>
		<div class="grid grid-cols-1">
			<select
				v-model="model"
				:name="name"
				:class="[
					'w-full h-16 rounded border py-3.5 shadow-sm px-3 border-gray-300',
					'focus:outline-0 focus:ring-2 focus:ring-offset-2 focus:ring-purple-500',
					'text-gray-900 placeholder:text-gray-400 text-functional-size-md',
					'col-start-1 row-start-1 w-full appearance-none rounded-md bg-white',
					errorMessages.length > 0
						? 'ring-2 ring-offset-2 ring-red-500'
						: '',
				]"
				:data-test-error="errorMessages.length > 0 ? true : undefined"
				:disabled="isDisabled || isReadonly"
				:required="isRequired"
				@select="(e) => validate((e.target as HTMLSelectElement).value)"
				@focusout="(e) => validate((e.target as HTMLSelectElement).value)"
			>
				<option
					v-for="option in options"
					:key="`atom-input-select-${name}-${option}`"
				>
					{{ option }}
				</option>
			</select>
		</div>
	</AtomInputUtilWrapper>
</template>

<script lang="ts" setup>
import type { InputPropDefaultsType } from '#base/core/types/InputPropDefaultsType';
import validatorStringInput from '#base/helpers/validators/validatorStringInput';

const props = defineProps<
	InputPropDefaultsType & {
		title: string;
		options: string[];
	}
>();

const model = defineModel<string>();

const errorMessages = ref<string[]>([]);

function validate(value: string) {
	const messages = [
		...validatorStringInput(value, {
			isRequired: props.isRequired,
			isDisabled: props.isDisabled,
			fieldName: props.title,
		}),
	];

	if (!props.options.includes(value)) {
		messages.push('Deze waarde is niet geldig.');
	}

	errorMessages.value = messages.length > 0 ? messages : [];
}
</script>
